/**
 * Created by dorin on 6/22/17.
 */
import React from 'react';
import { connect } from 'react-redux';
import actions from '../../redux/actions';

class Logout extends React.Component {
  componentWillMount() {
    const { dispatch, router } = this.props;

    dispatch(actions.logout());
    router.push('/login');
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(Logout);



// WEBPACK FOOTER //
// src/components/Auth/Logout.jsx